import React from 'react'
import { Field } from 'redux-form'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FilledInput from '@material-ui/core/FilledInput'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import LockOutlined from '@material-ui/icons/LockOutlined'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'

const useLabelStyles = makeStyles({
	root: {
		color: '#fff',
		marginLeft: 0,
		'&$focused': {
			color: '#fff'
		}
	},
	icon: {
		color: '#fff',
		height: '24px',
		width: '24px'
	},
	focused: {
		color: '#fff'
	},
	error: {
		backgroundColor: 'transparent'
	},
	selectMenu: {
		paddingLeft: '10px',
		color: '#fff',
		height: '1.21em'
	}
})

const renderSelectField = ({
	input,
	label,
	meta: { touched, error, invalid },
	children,
	name,
	labelStyles,
	regionLocked,
	...custom
}) => {
	return (
		<div data-testid="jurisdiction-selector" className="global-input-wrapper select-selector">
			<FormControl
				data-testid="jurisdiction-selector-formcontrol"
				error={touched && error} style={{ backgroundColor: 'rgb(36, 48, 65)' }} fullWidth>
				<InputLabel
					data-testid="jurisdiction-selector-label"
					htmlFor={name}
					classes={{
						root: labelStyles.root,
						focused: labelStyles.focused
					}}
					variant='filled'
					required
				>
					{label}
				</InputLabel>
				<Select
					data-testid="jurisdiction-selector-select"
					fullWidth
					error={touched && invalid}
					errorText={touched && error}
					{...input}
					{...custom}
					inputProps={{
						name: name,
						id: name
					}}
					classes={{ icon: labelStyles.icon, selectMenu: labelStyles.selectMenu }}
					input={<FilledInput id={name} name={name} style={{ padding: 0, color: '#fff' }} />}
					IconComponent={regionLocked ? LockOutlined : ArrowDropDown}
				>
					{children}
				</Select>
			</FormControl>
			{touched && error && <div data-testid="jurisdiction-selector-error" style={{
				color: '#f1493e',
				fontSize: '15px'
			}}>{error}</div>}
		</div>
	)
}

const JurisdictionSelector = ({ label, name, onChange, data, classes, validators, regionLocked, ...other }) => {
	const labelStyles = useLabelStyles()
	return (

		<Field
			data-testid="jurisdiction-selector-field"			
			component={renderSelectField}
			name={name}
			onChange={onChange}
			label={label}
			labelStyles={labelStyles}
			validate={validators}
			regionLocked={regionLocked}
			{...other}
		>
			{data &&
				data.map((r) => (
					<MenuItem data-testid="jurisdiction-selector-menu-item" key={r.id} value={r.id}>
						{r.name}
					</MenuItem>
				))}
		</Field>

	)
}

export default JurisdictionSelector
